import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  submitted = false;
  error: Boolean = false;
  success: Boolean = false;
  formValid = false;
  personalData: any;
  companyData: any;
  contractData: any;
  costoSingolaVisura: any;
  userCostForm: FormGroup;
  dataJSON: any;
  clientId: any;
  adminUser: Boolean = false;
  data: any;
  reportDefaultVal: any;
  crifAndCribisEnabled: any;
  cervedEnabled: any;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService,
    private formBuilder: FormBuilder,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.adminUser = this.authService.isAdmin();

    this.clientId = this.route.snapshot.paramMap.get('clientId');

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.USER_DETAIL");

    this.userCostForm = this.costFormBuilder(this.formBuilder);

    this.userService.getClientDetail(this.clientId).subscribe(data => {

      this.data = data;
      console.log(data);

      if (data) {
        if (data.personalDetail) {
          this.personalData = data.personalDetail;
        }
        if (data.companyDetail) {
          this.companyData = data.companyDetail;
        }
        if (data.contractDocument) {
          this.contractData = data.contractDocument;
        }
        if (data.singleUserReportCost) {
          this.costoSingolaVisura = data.singleUserReportCost;
        }
        if(this.data && this.data.reportDefaultData && this.data.reportDefaultData.crifAndCribis && this.data.reportDefaultData.cerved) {
          if(this.data.reportDefaultData.crifAndCribis === 'true') {
            this.reportDefaultVal = 'cc';
          } else if(this.data.reportDefaultData.cerved === 'true') {
            this.reportDefaultVal = 'ce';
          }
        }
        this.userCostForm = this.costFormBuilder(this.formBuilder);
      }
      this.spinnerService.stop();
    });

  }

  getContractDoc() {
    this.commonUtilService.downloadFile(this.contractData.contract.name, this.contractData.contract.fileBinary, true);
    return false;
  }

  costFormBuilder(formBuilder: FormBuilder) {
    return formBuilder.group({
      cost: [this.costoSingolaVisura, [Validators.required]],
      reportDefault: [this.reportDefaultVal, [Validators.required]]
    });
  }

  get f() { return this.userCostForm.controls; }

  get val() { return this.userCostForm.value; }


  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.success = false;
    this.error = false;

    if (this.userCostForm.invalid) {
      this.commonUtilService.findInvalidControls(this.userCostForm);
      this.error = true;
      this.spinnerService.stop();
      return;
    }

    this.dataJSON = {
      cost: this.val.cost,
    };

    let reportDataJson = {
      //crifAndCribis: this.crifAndCribisEnabled,
      crifAndCribis: false,
      cerved: this.cervedEnabled
    }

    this.userService.updateCost(this.clientId, this.dataJSON).subscribe(data => {
      this.userService.updateClinetReportDefault(this.clientId,reportDataJson).subscribe( dataReport => {
        this.success = true;
        this.spinnerService.stop();
        setTimeout(() => { this.success = false; }, 5000);
      }, err => {
        this.error = true;
      this.spinnerService.stop();
      })
    }, err => {
      this.error = true;
      this.spinnerService.stop();
    });
    this.formValid = true;
  }

  selectedReportDefaultData(val) {

    if (val !== undefined && val !== null && val !== '') {
      if (val === 'cc') {
        this.crifAndCribisEnabled = 'true';
        this.cervedEnabled = 'false';
      } else if (val === 'ce') {
        this.crifAndCribisEnabled = 'false';
        this.cervedEnabled = 'true';
      }
    }
  }

}


